import { createApp } from 'vue'
import '../styles/application.css'

import { mountCourseOverview } from '../pages/course_overview'
import { mountUnitLesson } from '../pages/unit_lesson'
import { mountPractice } from '../pages/practice'
import { mountReview } from '../pages/review'
import { mountVocabReview } from '../pages/vocab_review'
import { mountDeck } from '../pages/deck'
import { mountMistakes } from '../pages/mistakes'
import { mountConversation } from '../pages/conversation'
import { mountStory } from '../pages/story'
import { mountAlphabetGuide } from '../pages/alphabet'
import { mountGames } from '../pages/games'
import { mountProgress } from '../pages/progress'
import { mountSettings } from '../pages/settings'
import { mountDemo } from '../pages/demo'
import { mountLanding } from '../pages/landing'
import { mountPhrasebook } from '../pages/phrasebook'
import { mountDialectGuide } from '../pages/dialect_guide'
import { mountToneTrainer } from '../pages/tone_trainer'
import { mountTonePractice } from '../pages/tone_practice'
import { mountWord } from '../pages/word'
import { initAnalytics } from '../utils/analytics'

// Start product analytics once. Reads config from <meta> tags in the layout and
// no-ops when they're absent (dev/test), so it's safe to call on every boot.
initAnalytics()

function mountAll() {
  mountCourseOverview()
  mountUnitLesson()
  mountPractice()
  mountReview()
  mountVocabReview()
  mountDeck()
  mountMistakes()
  mountConversation()
  mountStory()
  mountAlphabetGuide()
  mountGames()
  mountProgress()
  mountSettings()
  mountDemo()
  mountLanding()
  mountPhrasebook()
  mountDialectGuide()
  mountToneTrainer()
  mountTonePractice()
  mountWord()
}

// Support both initial page load and Turbo navigations
document.addEventListener('turbo:load', mountAll)
document.addEventListener('DOMContentLoaded', () => {
  // Fallback if Turbo isn't active
  if (!document.documentElement.hasAttribute('data-turbo-preview')) {
    mountAll()
  }
})
